// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message {
  background-color: var(--ion-color-light);
  padding: 5px 10px;
  border-radius: 10px;
  margin-top: 10px;
}
.message .name {
  font-weight: bold;
  font-style: oblique;
  font-size: 0.9rem;
  padding-bottom: 5px;
}
.message.you {
  background-color: var(--ion-color-tertiary);
  color: var(--ion-color-tertiary-contrast);
}
.message .time {
  font-size: 0.6rem;
  text-align: right;
}
.ctn-btn-send-message {
  position: absolute;
  top: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/task/comments/comments.page.scss"],"names":[],"mappings":"AAAA;EACI,wCAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAAI;EACI,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAER;AAAI;EACI,2CAAA;EACA,yCAAA;AAER;AAAI;EACI,iBAAA;EACA,iBAAA;AAER;AAKA;EACI,kBAAA;EACA,SAAA;AAHJ","sourcesContent":[".message{\r\n    background-color: var(--ion-color-light);\r\n    padding: 5px 10px;\r\n    border-radius: 10px;\r\n    margin-top: 10px;\r\n    .name{\r\n        font-weight: bold;\r\n        font-style: oblique;\r\n        font-size: .9rem;\r\n        padding-bottom: 5px;\r\n    }\r\n    &.you{\r\n        background-color: var(--ion-color-tertiary);\r\n        color: var(--ion-color-tertiary-contrast);\r\n    }\r\n    .time{\r\n        font-size: 0.6rem;\r\n        text-align: right;\r\n        .read{\r\n            //color: var(--ion-color-primary);\r\n        }\r\n    }\r\n}\r\n\r\n.ctn-btn-send-message{\r\n    position: absolute;\r\n    top: 18px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
